/**
 * Up/down chevron used as a collapse indicator: `open` points up, otherwise down.
 */
function Chevron({ open, size = 20, color = '#888' }) {
    const d = open
        ? 'M8.7868 38.7867L30 17.5735L51.2132 38.7867L46.9706 43.0293L30 26.0588L13.0294 43.0293L8.7868 38.7867Z'
        : 'M51.2132 21.2133L30 42.4265L8.7868 21.2133L13.0294 16.9707L30 33.9412L46.9706 16.9707L51.2132 21.2133Z';

    return (
        <svg width={size} height={size} viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d={d} fill={color} />
        </svg>
    );
}

export default Chevron;
